export default {
  home: {
    to: '/',
    name: 'Domov',
  },
  loading: { to: '/loading' },
  prispevokVestnika: {
    add: {
      to: '/vytvorenie-prispevku',
      name: 'Pridanie príspevku do rezortnej zbierky',
    },
    update: {
      to: '/rezortne-zbierky/:uuid/uprava',
      withParams: (uuid: string): string => `/rezortne-zbierky/${uuid}/uprava`,
      name: 'Úprava príspevku do rezortnej zbierky',
    },
    list: {
      to: '/rezortne-zbierky',
      name: 'Rezortné zbierky',
    },
    detail: {
      raw: '/rezortne-zbierky/:uuid',
      withParams: (uuid: string): string => `/rezortne-zbierky/${uuid}`,
    },
  },
};
